"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadingPart = exports.LoadingPartDefaultProps = void 0;
var React = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var loading_layout_1 = require("../../elements/loading-layout");
var global_style_1 = require("../../elements/global-style");
;
exports.LoadingPartDefaultProps = {
  spinnerColor: 'primary'
};
// -------- Styles -------->
var LayoutStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    height: 100vh;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n    flex-direction: column;\n  "], ["\n    height: 100vh;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n    flex-direction: column;\n  "]))),
  desktop: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  "], ["\n  "])))
});
// -------- Components -------->
var My = {
  Container: (0, styled_components_1.default)(loading_layout_1.LoadingLayout)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), LayoutStyles)
};
var LoadingPart = function (_a) {
  var children = _a.children,
    spinnerColor = _a.spinnerColor;
  return React.createElement(React.Fragment, null, React.createElement(global_style_1.GlobalStyle, null), React.createElement(My.Container, null));
};
exports.LoadingPart = LoadingPart;
exports.LoadingPart.defaultProps = exports.LoadingPartDefaultProps;
var templateObject_1, templateObject_2, templateObject_3;